import script from "./sbh3.vue?vue&type=script&setup=true&lang=js"
export * from "./sbh3.vue?vue&type=script&setup=true&lang=js"

import "./sbh3.vue?vue&type=style&index=0&id=57ec68de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57ec68de"]])

export default __exports__